var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "attribute-picker" },
    [
      _c("div", { staticClass: "search-panel" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchText,
              expression: "searchText",
            },
          ],
          attrs: {
            maxlength: "128",
            placeholder: _vm.$t("chatbotv2.typeSearchValue"),
            type: "text",
          },
          domProps: { value: _vm.searchText },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.searchText = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "material-icons" }, [_vm._v(" search ")]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btnGroup" },
        _vm._l(_vm.allowedContexts, function (context) {
          return _c(
            "SupsisButton",
            {
              key: context,
              attrs: {
                classNames:
                  _vm.selectedContext === context
                    ? "btnGroupItem selected"
                    : "btnGroupItem ",
                primary: _vm.selectedContext === context,
                ghost: _vm.selectedContext !== context,
                small: "",
              },
              on: {
                click: function () {
                  return _vm.changeSelectedContext(context)
                },
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$_.startCase(context)) +
                  "\n        "
              ),
            ]
          )
        }),
        1
      ),
      _vm._v(" "),
      _vm.selectedContext === "general"
        ? _c("GeneralAttributePicker", {
            attrs: {
              "story-id": _vm.storyId,
              "default-selected": _vm.defaultSelected,
              pick: _vm.pick,
              "filter-mode": _vm.filterMode,
              "search-text-prop": _vm.searchText,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedContext === "table"
        ? _c("TableAttributePicker", { attrs: { "on-picked": _vm.pick } })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedContext === "api"
        ? _c("APIAttributePicker", { attrs: { "on-picked": _vm.pick } })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedContext === "websearch"
        ? _c("WebSearchAttributePicker", { attrs: { "on-picked": _vm.pick } })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedContext === "aicall"
        ? _c("AICallAttributePicker", { attrs: { "on-picked": _vm.pick } })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedContext === "runjavascript"
        ? _c("RunJavaScriptAttributePicker", {
            attrs: { "on-picked": _vm.pick },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedContext === "customblock"
        ? _c("CustomBlockAttributePicker", { attrs: { "on-picked": _vm.pick } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }